<app-dialog
  #dialog
  [key]="'company-sector-assign-modal'"
  [action]="'company-sector-assign'"
  [headerTheme]="'simple'"
  [title]="'Trocar setor'"
  [appendTo]="'body'"
  [hideDefaultFooter]="true"
  [maxWidth]="'520px'">
  <div class="sector-assign">
    <p class="sector-assign__summary">
      {{ companyCount() }}
      {{ companyCount() === 1 ? 'empresa selecionada' : 'empresas selecionadas' }}:
      <strong>{{ companyPreview().join(', ') }}</strong>
      @if (remainingCount() > 0) {
        <span> e mais {{ remainingCount() }}</span>
      }
    </p>

    @if (exceedsLimit()) {
      <p class="sector-assign__error">
        Troque o setor de no máximo {{ maxCompanies }} empresas por vez. Desmarque algumas e tente
        de novo.
      </p>
    }

    <app-select
      [label]="'Novo setor'"
      [placeholder]="'Escolha o setor'"
      [options]="sectorOptions()"
      [loading]="isLoadingSectors()"
      [ngModel]="selectedSector()"
      (ngModelChange)="selectedSector.set($event || null)"
      [emptyFilterMessage]="
        'Nenhum setor com esse nome. Peça a um administrador da Legatus para cadastrar.'
      " />

    <p class="sector-assign__help">
      O setor de todas as empresas selecionadas é trocado de uma vez. Se alguma delas não puder ser
      alterada, nenhuma muda. A atividade principal (CNAE) não é alterada.
    </p>
  </div>

  <ng-template #footer>
    <div class="dialog__footer">
      <app-button
        [disabled]="!isFormValid() || isSaving()"
        [isLoading]="isSaving()"
        [loadingText]="'Salvando...'"
        [label]="'Trocar setor'"
        (sendButtonClick)="submitAction()">
      </app-button>
    </div>
  </ng-template>
</app-dialog>
